export default function downloadStringAsFile(filename: string, text: string) {
  const pom = document.createElement("a");
  pom.setAttribute(
    "href",
    `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`
  );
  pom.setAttribute("download", filename);
  if (document.createEvent) {
    const event = document.createEvent("MouseEvents");
    event.initEvent("click", true, true);
    pom.dispatchEvent(event);
  } else {
    pom.click();
  }
}
